import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonService } from '../../../services/common.service';
import { DeviceGroupService } from '../../../services/assets-management/device-group.service';
import { DeviceGroup, ReqAddDeviceGroup } from '../../../models/assets-management/device-group';
import { ActionEnum, StatusEnum } from '../../../models/common-enum';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import * as _ from 'lodash';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { permission } from 'src/app/views/assets-management/_menu';
@Component({
  selector: 'app-device-group',
  templateUrl: './device-group.component.html',
  styleUrls: ['./device-group.component.scss']
})
export class DeviceGroupComponent implements OnInit {
  @ViewChild('addModal', { static: false }) public addModal: ModalDirective;
  @ViewChild('deleteModal', { static: false }) public deleteModal: ModalDirective;
  @ViewChild('swalSuccess', { static: false }) private swalSuccess: SwalComponent;
  @ViewChild('swalError', { static: false }) private swalError: SwalComponent;
  statusEnum = StatusEnum;
  myDate = new Date();
  currentPage: any = 1;
  itemsPerPage: any = 10;
  totalItems: any = 0;
  data_list: DeviceGroup[];
  status_list = [
    { id: StatusEnum.Active, name: "Active" },
    { id: StatusEnum.Inactive, name: "Inactive" }
  ];
  status: any;
  selectItem: any = {
    name: "",
    desc: "",
    code: "",
    status: null
  };
  public allowCustom: boolean = false;
  res_message: any;
  status_modal: any;
  search_group_name: any;

  isAdd: boolean = false;
  isEdit: boolean = false;
  constructor(private commonService: CommonService, private deviceGroupService: DeviceGroupService) { 
    this.commonService.activityLog(ActionEnum.Get, `Assets Management ➡ Configuration ➡ กลุ่มอุปกรณ์`).subscribe(res => { }, error => { console.log(error); });
  }

  async ngOnInit() {
    //this.getRoute();
    this.is_loading = true;
    this.getDeviceGroup();
    this.isAdd = await this.commonService.getPermission(permission.configuration.device_group.add_id).toPromise();
    this.isEdit = await this.commonService.getPermission(permission.configuration.device_group.edit_id).toPromise();
  }

  handleValueStatus(value) {
    if (value) {
      //console.log(value);
      this.status = value;
    } else {
      this.status = null;
    }
  }
  is_loading: boolean = false;
  route: string;
  public data_route: Array<string>;
  route_list: string[];
  getRoute() {
    this.commonService.getRoute().subscribe(
      res => {
        if (res) {
          if (res.code == 1) {
            if (res.data) {
              this.route_list = _.cloneDeep(res.data);
              this.data_route = _.cloneDeep(res.data);
            }
          }
        }
        this.is_loading = false;
      },
      error => {
        this.is_loading = false;
      });
  }

  handleFilterHub(value) {
    if (value.length > 0) {
      this.data_route = this.route_list.filter((s) => s.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    } else if (value.length == 0) {
      this.data_route = _.cloneDeep(this.route_list);
    } else {
      this.data_route = [];
    }
  }
  handleValueHub(value) {
    if (value) {
      //console.log(value);
      this.route = value;
    } else {
      this.route = null;
    }
  }
  search() {
    this.currentPage = 1;
    this.getDeviceGroup();
  }
  getDeviceGroup() {
    this.data_list = [];
    let sta = null;
    if (this.status)
      sta = this.status.id;
    this.deviceGroupService.getDeviceGroup(this.search_group_name, sta, this.currentPage, this.itemsPerPage).subscribe(
      res => {
        if (res) {
          if (res.code == 1) {
            if (res.data) {
              this.data_list = res.data.data;
              this.totalItems = res.data.total_items;
            }else{
              this.totalItems = 0;
            }
          }else{
            this.totalItems = 0;
          }
        }else{
          this.totalItems = 0;
        }
        this.is_loading = false;
      },
      error => {
        this.is_loading = false;
        this.totalItems = 0;
      });
  }
  openAddModal() {
    this.selectItem = new DeviceGroup();
    this.selectItem.name = "";
    this.selectItem.desc = "";
    this.selectItem.code = "";
    this.selectItem.status = null;
    this.status_modal = null;
    this.addModal.show();
  }
  openEditModal(item?: any) {
    this.selectItem = item;
    this.status_modal = this.status_list.find(x => x.id == item.status);
    this.addModal.show();
  }
  openDeleteModal(item?: any) {
    this.selectItem = item;
    this.status_modal = this.status_list.find(x => x.id == item.status);
    this.deleteModal.show();
  }
  clearData() {
    this.selectItem = new DeviceGroup();
  }
  handleValueStatusModal(value) {
    if (value) {
      //console.log(value);
      this.status_modal = value;
    } else {
      this.status_modal = null;
    }
  }
  pageChanged(event: any): void {
    if (this.currentPage != event.page) {
      this.currentPage = event.page;
      this.getDeviceGroup();
    }
  }
  addDeviceGroup() {
    this.is_loading = true;
    let req = new ReqAddDeviceGroup();
    req.name = this.selectItem.name;
    req.desc = this.selectItem.desc;
    req.code = this.selectItem.code;
    req.status = this.status_modal.id;
    this.res_message = "";
    this.deviceGroupService.addDeviceGroup(req).subscribe(
      res => {
        if (res) {
          if (res.code == 1) {
            const log_req_data = { url: `${this.deviceGroupService.domain}/${this.deviceGroupService.uri}`, request: req, response: res };
            this.commonService.activityLog(ActionEnum.Add, `Assets Management ➡ Configuration ➡ กลุ่มอุปกรณ์`, JSON.stringify(log_req_data)).subscribe(res => { }, error => { console.log(error); });
            this.res_message = `เพิ่มกลุ่มอุปกรณ์สำเร็จ`;
            setTimeout(() => {
              this.swalSuccess.fire();
              this.is_loading = false;
              this.getDeviceGroup();
            }, 100);
            this.addModal.hide();
          } else {
            this.res_message = res.message;
            setTimeout(() => { this.swalError.fire(); this.is_loading = false; }, 100);
          }
        } else {
          setTimeout(() => { this.swalError.fire(); this.is_loading = false; }, 100);
        }
      },
      error => {
        console.log(error);
        if (error) {
          if (error.status == 403) {

          } else {
            const error_text = error.error.message || error.statusText;
            this.res_message = error_text;
            this.is_loading = false;
            setTimeout(() => { this.swalError.fire() }, 1000);
          }
        } else {
          setTimeout(() => { this.swalError.fire() }, 1000);
        }
        this.is_loading = false;
      });
  }
  editDeviceGroup() {
    this.is_loading = true;
    let req = new ReqAddDeviceGroup();
    req.name = this.selectItem.name;
    req.desc = this.selectItem.desc;
    req.code = this.selectItem.code;
    req.status = this.status_modal.id;
    this.res_message = "";
    this.deviceGroupService.editDeviceGroup(req, this.selectItem.id).subscribe(
      res => {
        if (res) {
          if (res.code == 1) {
            const log_req_data = { id: this.selectItem.id, request: req, response: res, url: `${this.deviceGroupService.domain}/${this.deviceGroupService.uri}/${this.selectItem.id}` };
            this.commonService.activityLog(ActionEnum.Edit, `Assets Management ➡ Configuration ➡ กลุ่มอุปกรณ์`, JSON.stringify(log_req_data)).subscribe(res => { }, error => { console.log(error); });
            this.res_message = `แก้ไขกลุ่มอุปกรณ์สำเร็จ`;
            setTimeout(() => {
              this.swalSuccess.fire();
              this.is_loading = false;
              this.getDeviceGroup();
            }, 100);
            this.addModal.hide();
          } else {
            this.res_message = res.message;
            setTimeout(() => { this.swalError.fire(); this.is_loading = false; }, 100);
          }
        } else {
          setTimeout(() => { this.swalError.fire(); this.is_loading = false; }, 100);
        }
      },
      error => {
        console.log(error);
        if (error) {
          if (error.status == 403) {

          } else {
            const error_text = error.error.message || error.statusText;
            this.res_message = error_text;
            this.is_loading = false;
            setTimeout(() => { this.swalError.fire() }, 1000);
          }
        } else {
          setTimeout(() => { this.swalError.fire() }, 1000);
        }
        this.is_loading = false;
      });
  }

  deleteDeviceGroup() {
    this.is_loading = true;
    let req = new ReqAddDeviceGroup();
    req.name = this.selectItem.name;
    req.desc = this.selectItem.desc;
    req.code = this.selectItem.code;
    req.status = this.status_modal.id;
    this.res_message = "";
    this.deviceGroupService.deleteDeviceGroupEditStatus(req, this.selectItem.id).subscribe(
      res => {
        if (res) {
          if (res.code == 1) {
            this.commonService.activityLog(ActionEnum.Delete, `Assets Management ➡ Configuration ➡ กลุ่มอุปกรณ์`, JSON.stringify({ id: this.selectItem.id, url: `${this.deviceGroupService.domain}/${this.deviceGroupService.uri}/${this.selectItem.id}` })).subscribe(res => { }, error => { console.log(error); });
            this.res_message = `ลบกลุ่มอุปกรณ์สำเร็จ`;
            setTimeout(() => {
              this.swalSuccess.fire();
              this.is_loading = false;
              this.getDeviceGroup();
            }, 100);
            this.deleteModal.hide();
          } else {
            this.res_message = res.message;
            setTimeout(() => { this.swalError.fire(); this.is_loading = false; }, 100);
          }
        } else {
          setTimeout(() => { this.swalError.fire(); this.is_loading = false; }, 100);
        }
      },
      error => {
        console.log(error);
        if (error) {
          if (error.status == 403) {

          } else {
            const error_text = error.error.message || error.statusText;
            this.res_message = error_text;
            this.is_loading = false;
            setTimeout(() => { this.swalError.fire() }, 1000);
          }
        } else {
          setTimeout(() => { this.swalError.fire() }, 1000);
        }
        this.is_loading = false;
      });
  }

}
